import React, { useCallback, useEffect, useState } from "react";
import ChildPic from "../../../../assets/images/child.jpg";
import { Link } from "react-router-dom/cjs/react-router-dom";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  ZAxis,
  Tooltip,
  Legend,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import useKidListFunctionality from "../../../customHooks/kidListHook";
import CommonStatus from "../Common/CommonStatus";
import useDeviceStatus from "../../../customHooks/deviceStatusProvider";
import Select from "react-select";
import SetRulesDisableSupervison from "../SetRules/SetRulesDisableSupervison";
import useSetRules from "../SetRules/useSetRules";
import useLangTranslation from "../../../customHooks/languageProvider";
import DeleteChildInfo from "../modals/DeleteChildInfo";
import { getMyIPAddress } from "../../AxiosRtk/Miscellaneous";
import { deleteKidAccount } from "../../AxiosRtk/AddNewChild";
import { setSelectedKidId } from "../../AxiosRtk/DashBoard";
import { handleStartDateCommon } from "../../../../utils/helper";
import moment from "moment";
import useDurationOption from "../../../customHooks/durationOption";
import { setActiveTab, setRuleDataSetUp } from "../../AxiosRtk/SetRules";
import SetDailyLimitModal from "../modals/SetDailyLimitModal";
import { getScreenTimeData } from "../../AxiosRtk/ScreenTime";
import { isEmpty } from "lodash";
import useFirebase from "../../../../useFirebase";
import AddNewApp from "../modals/AddNewApp";
import AddTimeLimit from "../modals/AddTimeLimit";
import useSubscription from "../../../customHooks/subscriptionProvider";
import KidImage from "../../../shared/KidImage/KidImage";
import DateFilter from "../../../shared/DateFilter/DateFilter";
import { useDashboardDataProvider } from "../../../customHooks/dashboardDataProvider";

const ScreenTime = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { handleDeviceSelection } = useDashboardDataProvider();
  const [deviceStatus, setDeviceStatus] = useState("");

  const { getDeviceStatusData } = useDeviceStatus(
    deviceStatus,
    setDeviceStatus
  );
  const { checkSubsciption } = useSubscription();
  const [showModal, setShowModal] = useState(false);
  const [showDailyLimitModal, setShowDailyLimitModal] = useState(false);
  const { getLangTranslation } = useLangTranslation();
  const { setRulesData } = useSelector(({ setRules }) => setRules);
  const { durationOptionsFunction } = useDurationOption();
  const [selectedDuration, setSelectedDuration] = useState(1);
  const durationOptions = durationOptionsFunction();
  const [kidData, setKidData] = useState(false);
  const AdminSetRuleLanguageData = useSelector(({ setRules }) => setRules);
  const { appLanguageId } = useSelector(({ misc }) => misc);
  const { getImage } = useKidListFunctionality();
  const [graphData, setGraphData] = useState([]);
  const [bars, setBars] = useState([]);
  const [appTimeAvailableData, setAppTimeAvailableData] = useState([]);
  const [error, setError] = useState("");
  const [barGraphData, setBarGraphData] = useState([]);
  const [newAppModal, setNewAppModal] = useState(false);
  const [showDeletedModal, setShowDeletedModal] = useState(false);
  const [appId, setAppId] = useState(null);
  const { allAppData } = useSelector(({ dashboard }) => dashboard);
  const initialEndDate = moment().locale("en").format("YYYY-MM-DD HH:mm:ss");
  const [endDate, setEndDate] = useState(initialEndDate);
  const { kidDevicesList, kidList, selectedKidId, selectedDeviceData } =
    useSelector(({ dashboard }) => dashboard);
  const { handleTimeSupervision } = useSetRules();
  const lang =
    AdminSetRuleLanguageData?.AdminSetRuleLanguageData?.languages?.find(
      (item) => item?.id === appLanguageId
    );
  const [topAppsData, setTopAppsData] = useState([]);
  const [reason, setReason] = useState({ value: "", error: "" });
  const [deviceOptions, setDeviceOptions] = useState([]);
  const [loader, setLoader] = useState(false);
  const [startDate, setStartDate] = useState(
    moment().startOf("day").format("YYYY-MM-DD HH:mm:ss")
  );
  const [appDelModeData, setAppDelModeData] = useState({ isDel: 0, time: "" });
  const [appEditModeData, setEditModeData] = useState({
    isEdit: 0,
    day: "",
    hours: 0,
    minutes: 0,
  });
  const { getCollectionData, postCollectionData, createCollectionData } =
    useFirebase();
  const handleGoBack = () => {
    history.goBack();
  };

  function closeModal() {
    setShowModal(false);
  }

  useEffect(() => {
    setKidData(kidList?.find((item, index) => item.ID == selectedKidId));
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (selectedDeviceData) {
      getDeviceStatusData(selectedDeviceData?.ID);
    }
  }, [selectedDeviceData]);

  useEffect(() => {
    if (selectedDeviceData) {
      getCollectionData(selectedDeviceData?.ID);
    } else {
      dispatch(setRuleDataSetUp(null));
    }
  }, [selectedDeviceData]);

  useEffect(() => {
    setDeviceOptions(
      kidDevicesList?.map((item) => {
        return { value: item?.ID, label: item?.Name };
      })
    );
  }, [kidDevicesList]);

  const getPublicIp0 = useCallback(async () => {
    try {
      const { data: ipAddData } = await getMyIPAddress();
      return ipAddData?.ip;
    } catch (error) {
      console.log("Ip0", error);
    }
  }, []);

  const openDailyLimitModal = () => {
    setShowDailyLimitModal(true);
  };
  const closeDailyLimitModal = () => {
    setShowDailyLimitModal(false);
  };

  async function handleContinue() {
    if (!reason?.value) {
      setReason({
        ...reason,
        error: "Please enter reason",
      });
      return;
    }

    setLoader(true);

    const ip = await getPublicIp0();

    const deleteProfilePayload = {
      kidId: selectedKidId,
      kidName: kidData?.childName,
      ipAddress: ip,
      reason: reason?.value,
    };

    deleteKidAccount(deleteProfilePayload)
      .then((res) => {
        closeModal();
        setShowDeletedModal(true);
      })
      .catch((err) => {
        setReason({
          ...reason,
          error: err?.response?.data?.message + ". Redirecting to dashboard.",
        });
        setTimeout(() => {
          window.location.href = "/dashboard";
        }, 2500);
        console.log(
          "child delete catch error ==>>",
          err?.response?.data?.message
        );
      })
      .finally(() => {
        setLoader(false);
        dispatch(setSelectedKidId(kidList[0]?.ID));
      });
    // console.log(deleteProfilePayload)
  }

  function getScreenTimeGraphData() {
    if (selectedDeviceData && startDate) {
      const filterDate = moment(startDate)
        .locale("en")
        .format("YYYY-MM-DD HH:mm:ss");
      const obj = {
        pageOffset: 1,
        pageLimit: 100000,
        startDate: startDate,
        endDate: endDate,
        kidId: selectedKidId,
        deviceId: selectedDeviceData?.ID,
      };
      getScreenTimeData(obj)
        .then((res) => {
          // console.log(res?.data?.result);
          setGraphData(res?.data?.result[0]?.graphData);
          setTopAppsData(res?.data?.result[0]?.topApps);
        })
        .catch((err) => {
          console.log("rating catch error ==>>", err?.response?.data?.message);
        });
    }
  }

  function timeConverter(seconds, hmOnly = false) {
    if (!seconds) return 0;
    var hours = Math.floor(seconds / 3600);
    var minutes = Math.floor((seconds - hours * 3600) / 60);
    seconds = seconds - hours * 3600 - minutes * 60;

    if (hmOnly) {
      return `${hours < 10 ? `0${hours}` : hours}:${minutes < 10 ? `0${minutes}` : minutes
        }`;
    }

    // Add leading zero to single-digit minutes and seconds
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    if (seconds < 10) {
      seconds = "0" + seconds;
    }

    return `${hours}h ${minutes}m ${seconds}s`;
  }

  useEffect(() => {
    if (!isEmpty(graphData)) {
      const barMap = new Map();
      const graphBarMap = new Map();

      graphData.forEach((item) => {
        if (item?.category && item?.color && !barMap.has(item?.category)) {
          barMap.set(item?.category, item?.color);
        }
        if (graphBarMap.has(Number(item?.hour))) {
          const categoryObj = { ...graphBarMap.get(Number(item?.hour)) };
          if (categoryObj[item?.category?.split(" ")[0]]) {
            categoryObj[item?.category?.split(" ")[0]] =
              +categoryObj[item?.category?.split(" ")[0]] + +item?.duration;
          } else {
            categoryObj[item?.category?.split(" ")[0]] = item?.duration;
          }
          // const obj = { ...graphBarMap.get(Number(item?.hour)), [item?.category?.split(' ')[0]]: item?.duration }
          graphBarMap.set(Number(item?.hour), categoryObj);
        } else {
          const tempObj = {
            name: Number(item?.hour),
            [item?.category?.split(" ")[0]]: item?.duration,
          };
          graphBarMap.set(Number(item?.hour), { ...tempObj });
        }
      });
      const dataBarMap = Array.from(barMap, ([key, value]) => ({
        dataKey: key,
        fill: value,
      }));
      setBars(dataBarMap);

      const graphBarMapData = Array.from(graphBarMap, ([key, value]) => value);
      // console.log(graphBarMapData)
      // setGraphData(graphBarMapData);
      setBarGraphData(graphBarMapData);
    }
  }, [graphData]);

  useEffect(() => {
    getScreenTimeGraphData();
  }, [startDate, selectedDeviceData, endDate]);

  const showNewAppModal = () => {
    setNewAppModal(true);
  };

  const closeNewAppModal = () => {
    setNewAppModal(false);
  };

  function editTimeLimit(appId, day, timeInMinutes) {
    if (!checkSubsciption()) {
      return;
    }
    setAppId(appId);
    setEditModeData({
      isEdit: 1,
      day,
      hours: Math.floor(parseInt(timeInMinutes) / 60),
      minutes: parseInt(timeInMinutes) % 60,
    });
    setTimeout(() => {
      setShowDeletedModal(true);
    }, 1000);
  }

  function handleDeleteTimeLimit(appId, day, timeStr) {
    if (!checkSubsciption()) {
      return;
    }
    setAppId(appId);
    setAppDelModeData({ isDel: 1, time: timeStr });
    setTimeout(() => {
      setShowDeletedModal(true);
    }, 1000);
  }

  function delModalOpen() {
    closeNewAppModal();
    setShowDeletedModal(true);
  }

  function handleContinueBtn() {
    // console.log("app id ==>>", appId)
    let flag = true;
    if (isEmpty(appId)) {
      flag = false;
      setError("PLS_SELECT_APP_TXT");
    }

    if (flag) {
      delModalOpen();
    }
  }

  function closeDeletedModal() {
    setShowDeletedModal(false);
  }

  const addNewAppFun = () => {
    if (!checkSubsciption()) {
      return;
    }
    showNewAppModal();
    closeDailyLimitModal();
  };

  function isAppShowInList(item) {
    if (isEmpty(item?.DailyLimit)) {
      return false;
    }

    let flag = false;
    for (const key in item?.DailyLimit) {
      if (item?.DailyLimit[key] > 0) {
        flag = true;
      }
    }

    return flag;
  }

  useEffect(() => {
    if (allAppData?.length > 0) {
      const filterAppTimeData = allAppData?.filter((element) =>
        isAppShowInList(element)
      );
      setAppTimeAvailableData(filterAppTimeData);
    }
  }, [allAppData]);

  return (
    <>
      <div className="card mb-6">
        <div className="card-body">
          <div className="inline-list-wrap separator space-24">
            <div className="list-item">
              <div className="list-content">
                <div className="d-inline-flex align-items-center lh-1">
                  <Link
                    to="/"
                    className="text-blue-900 fs-5"
                    onClick={handleGoBack}
                  >
                    <i
                      className={`${lang?.isRTL === 1
                        ? "icon-arrow-right"
                        : "icon-arrow-left"
                        }`}
                    />
                  </Link>
                  <h3 className="text-blue-900 mb-0">
                    {getLangTranslation(
                      "CHILD_DETAIL_SCREEN_TIME",
                      "Screen Time"
                    )}
                  </h3>
                </div>
              </div>
            </div>
            <div className="list-item">
              <KidImage imageUrl={kidData?.image} gender={kidData?.gender} />
              <div>
                <h5 className="text-blue-900 mb-0">{kidData?.childName}</h5>

                <CommonStatus status={deviceStatus} />
              </div>
            </div>
            <div className="list-item content-300 w-100">
              <div className="select-with-icon">
                <span className="icon-wrap icon-blue pt-cursor border-0">
                  <i className="icon-mobile fs-5" />
                </span>
                <Select
                  className="custom-select "
                  classNamePrefix="custom-select"
                  placeholder={getLangTranslation(
                    "SCREEN_TIME_SELECT_DEVICE",
                    "Select Device"
                  )}
                  options={deviceOptions}
                  value={
                    deviceOptions?.find(
                      (item) => item?.value == selectedDeviceData?.ID
                    ) || ""
                  }
                  onChange={handleDeviceSelection}
                  isSearchable={false}
                />
              </div>
            </div>

            <DeleteChildInfo
              showModal={showModal}
              closeModal={closeModal}
              handleContinue={handleContinue}
              loader={loader}
              reason={reason}
              setReason={setReason}
              getLangTranslation={getLangTranslation}
            />
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <div className="d-flex align-items-center justify-content-end flex-wrap gap-6 mb-9">
            <DateFilter
              startDate={startDate}
              endDate={endDate}
              setEndDate={setEndDate}
              setStartDate={setStartDate}
              selectedDuration={selectedDuration}
            />
            <Select
              className="custom-select col-lg-2"
              classNamePrefix="custom-select"
              placeholder="Select"
              onChange={(val) => {
                handleStartDateCommon(
                  val,
                  setStartDate,
                  setSelectedDuration,
                  setEndDate
                );
              }}
              options={durationOptions}
              value={
                durationOptions?.find(
                  (item) => item?.value == selectedDuration
                ) || ""
              }
            />
            {/* <button
              className="btn btn-outline-primary"
              type="button"
              onClick={openDailyLimitModal}
            >
              {getLangTranslation(
                "SCREEN_TIME_SCREEN_SET_DAILY_LIMIT_BTN",
                "Set daily limit"
              )}
            </button> */}
          </div>
          {/* <img src={screentimeGraphPic} className="w-100" alt="" />*/}
          {!isEmpty(graphData) ? (
            <div className="graph">
              <ResponsiveContainer width="100%" height={300}>
                <BarChart width={1000} height={500} data={barGraphData}>
                  <CartesianGrid strokeDasharray="3 3" />

                  {/* Ensure XAxis is inside the BarChart component */}
                  <XAxis dataKey="name" label={{ value: getLangTranslation("PARENT_DASHBOARD_HOURS", "Hours"), position: "insideBottom", offset: -5 }} />

                  {/* YAxis with label */}
                  <YAxis label={{ value: getLangTranslation("PARENT_DASHBOARD_GRAPH_FAMILY_SCREEN_X_AXIS_APP_USED_TIME", "App Used time"), angle: -90, position: "insideLeft" }} />

                  <Tooltip />
                  <Legend />

                  {/* Mapping over the bars and using proper dataKey */}
                  {bars.map((item) => {
                    console.log("item", item);

                    return (
                      <Bar
                        dataKey={item.dataKey.split(" ")[0]} // Ensure the split logic works correctly
                        stackId="a"
                        fill={item.fill}
                        key={item.fill}
                      />
                    )
                  })}
                </BarChart>
              </ResponsiveContainer>
            </div>


          ) : (
            <div className="text-center my-3">
              --{" "}
              {getLangTranslation(
                "PARENT_TASK_DATA_NOT_FOUND",
                "No data found !"
              )}{" "}
              --
            </div>
          )}

          <div className="d-flex align-items-center mb-6 mt-9 justify-content-between gap-3">
            <h5 className="mb-0 text-blue-900">
              {getLangTranslation("MOST_USED_TXT", "Most Used")}
            </h5>
            {/* <h6
              className="mb-0 text-blue-400 cursor-pointer"
              onClick={() => {
                history.push("/set-rules");
                dispatch(setActiveTab("SETRULE_APPS_MONITORING"));
              }}
            >
              {getLangTranslation("SET_TIME_LIMIT", "Set Time Limit")}
            </h6> */}
          </div>
          {topAppsData?.map((item, index) => (
            <div className="d-flex align-items-center mb-3">
              <span
                className={`icon-wrap border-0 ${lang?.isRTL === 1 ? "ms-3" : "me-3"
                  }`}
              >
                <img src={item?.appImage} alt="" />
              </span>
              <div className="flex-grow-1">
                <p className="d-flex justify-content-between mb-3">
                  {item?.appName} <span> {timeConverter(item.duration)}</span>
                </p>
                <div
                  className="progress"
                  role="progressbar"
                  aria-label="Basic example"
                  aria-valuenow="25"
                  aria-valuemin="0"
                  aria-valuemax="100"
                >
                  <div
                    className="progress-bar"
                    style={{
                      width: `${Math.floor(
                        (item.duration * 100) /
                        topAppsData?.reduce(
                          (prev, curr) => prev + curr?.duration,
                          0
                        )
                      )}%`,
                    }}
                  ></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <SetDailyLimitModal
        showModal={showDailyLimitModal}
        closeModal={closeDailyLimitModal}
        getLangTranslation={getLangTranslation}
        name={kidData?.childName}
        deviceId={selectedDeviceData?.ID}
        postCollectionData={postCollectionData}
        createCollectionData={createCollectionData}
        addNewApp={addNewAppFun}
        appTimeAvailableData={appTimeAvailableData}
      />
      <AddNewApp
        showModal={newAppModal}
        closeModal={closeNewAppModal}
        allAppData={allAppData}
        appId={appId}
        setAppId={setAppId}
        delModalOpen={delModalOpen}
        handleContinueBtn={handleContinueBtn}
        error={error}
      />

      <AddTimeLimit
        showDeletedModal={showDeletedModal}
        closeDeletedModal={closeDeletedModal}
        appId={appId}
        allAppData={allAppData}
        selectedKidId={selectedKidId}
        deviceId={selectedDeviceData?.ID}
        appEditModeData={appEditModeData}
        appDelModeData={appDelModeData}
        setEditModeData={setEditModeData}
        setAppDelModeData={setAppDelModeData}
      />
    </>
  );
};

export default ScreenTime;
